"use strict";
var MixinUtil = (function () {
    function MixinUtil() {
    }
    MixinUtil.applyMixins = function (derivedCtor, baseCtors) {
        baseCtors.forEach(function (baseCtor) {
            Object.getOwnPropertyNames(baseCtor.prototype).forEach(function (name) {
                if (name !== 'constructor') {
                    derivedCtor.prototype[name] = baseCtor.prototype[name];
                }
            });
        });
    };
    return MixinUtil;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MixinUtil;
